import { useNavigate } from 'react-router';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useSlackDeactivation = () => {
    const userApi: UserApi = useContainer(UserApi);
    const { t } = useTranslation('integrations');
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const SlackDeactivation = () => {
        const { exec, abort } = userApi.initialSlackDeactivation({
            onSuccess: () => {
                navigate('/integrations');
                toastHandler.push('success', t('slack.SLACK_DISABLE_SUCCEEDED_TITLE'), t('slack.SLACK_DISABLE_SUCCEEDED_MESSAGE'));
            },
            onError: error => {
                toastHandler.push('error', t('slack.SLACK_DISABLE_FAILED_TITLE'), t('slack.SLACK_DISABLE_FAILED_MESSAGE'));
                console.log(error);
            },
        });
        exec();
        return abort;
    };
    const SlackIndividualDeactivation = () => {
        const { exec, abort } = userApi.individualSlackDeactivation({
            onSuccess: () => {
                toastHandler.push(
                    'success',
                    t('slack.SLACK_INDIVIDUAL_DEACTIVATE_SUCCEEDED_TITLE'),
                    t('slack.SLACK_INDIVIDUAL_DEACTIVATE_SUCCEEDED_MESSAGE')
                );
            },
            onError: error => {
                toastHandler.push(
                    'error',
                    t('slack.SLACK_INDIVIDUAL_DEACTIVATE_FAILED_TITLE'),
                    t('slack.SLACK_INDIVIDUAL_DEACTIVATE_FAILED_MESSAGE')
                );
                console.log(error);
            },
        });
        exec();
        return abort;
    };

    return { SlackDeactivation, SlackIndividualDeactivation };
};

export default useSlackDeactivation;
